import { ContextMenu, Position } from "devextreme-react/context-menu";
import Button from "devextreme-react/button";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { QuoteStatus, QuoteTypes } from "../../../../types/enums";
import { EstimateContext } from "../context/EstimateContext";

export default function CreateEstimateButton() {

	const { order } = useContext(EstimateContext);
	const navigate = useNavigate();

	const menuItems = [
		{ text: 'Easy Estimator 2.0', icon: 'Inscyth-Easy-Estimator' },
		{ text: 'EE Pro Tool', icon: 'Inscyth-EEPro' }
	];

	return (
		<>
			<Button
				id="create-estimate-button"
				visible={order.details.imeStatus !== 'SALE' && order.details.statusID === QuoteStatus.Open &&
					order.details.quoteTypeID === QuoteTypes.Lead && !!order.details.easyEstimatorUrl}>
				<i className="dx-icon dx-icon-Inscyth-Easy-Estimator"></i>
				{order.details.quoteTypeID === QuoteTypes.Lead ? "Create Estimate" : "Create Revision"}
				<i className={'dx-icon dx-icon-chevrondown'}></i>
			</Button>
			<ContextMenu
				width={165}
				items={menuItems}
				target="#create-estimate-button"
				showEvent="click"
				onItemClick={(e) => {
					if (e.itemIndex === 0) {
						window.open(order.details.easyEstimatorUrl + '?loadEstimate=' + order.details.guid);
					}
					else {
						navigate('/cfi/easy-estimator/' + order.details.quoteID);
					}
				}}
			>
				<Position my='left top' at='left bottom'>
				</Position>
			</ContextMenu>
		</>
	)
}
